<script setup>
  /**
   * Locked teaser for users without `tool.alerts.use`: a title, one sentence
   * and a button to the subscriptions page. Rendered INSTEAD of any call to
   * `/v1/alerts`, so nobody gets the global upgrade modal for merely opening
   * Home. `source` names the entry point for the funnel analytics.
   */
  import AppButton from '@/components/ui/buttons/AppButton.vue';
  import AppRestrictedState from '@/components/ui/states/AppRestrictedState.vue';
  import { ACCESS_KEYS } from '@/config/entitlementKeys';
  import { alertsAnalytics } from '@/pages/alerts/alertsAnalytics';
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';

  const props = defineProps({
    /** Tighter layout for the Home / Mijn-omgeving cards. */
    compact: { type: Boolean, default: false },
    /** Entry point: `home_card`, `my_environment_card` or `alerts_page`. */
    source: { type: String, default: 'alerts_page' },
  });

  const { t } = useI18n();
  onMounted(() => alertsAnalytics.teaserShown({ entryPoint: props.source }));
  const onUpgrade = () => alertsAnalytics.upgradeClicked({ entryPoint: props.source, reason: 'locked' });

  const subscriptionsRoute = { name: 'subscriptions', query: { upgrade: ACCESS_KEYS.TOOL_ALERTS } };
</script>

<template>
  <app-restricted-state
    data-test="alerts-locked-teaser"
    :compact="compact"
    :title="t('alerts.locked.title')"
    :message="t('alerts.locked.message')"
    :entitlement-key="ACCESS_KEYS.TOOL_ALERTS"
  >
    <app-button
      data-test="alerts-locked-teaser-upgrade"
      tone="primary"
      :size="compact ? 'sm' : undefined"
      :to="subscriptionsRoute"
      :label="t('alerts.locked.cta')"
      @click="onUpgrade"
    />
  </app-restricted-state>
</template>
